window.__WXLOGINWINDOW__ = (() => {
	let _win = null;
	return {
		/**
		 * 打开微信登录弹窗
		 */
		open(url) {
			if (_win && _win.closed === false) {
				_win.focus && _win.focus();
				return;
			}
			this.close();
			let l = (window.screen.width - 670) / 2;
			let t = (window.screen.height - 560) / 2;
			_win = window.open(url, 'wxWindow', 'toolbar=no, directories=no, status=no, menubar=no, width=670, height=560, top=' + t + ', left=' + l);
			_win.focus();
			console.log('wxWindow', _win);
		},
		/**
		 * 关闭微信登录弹窗
		 */
		close() {
			console.log('try close _win', _win);
			if (!_win) {
				console.log('failed: wxWindow not found');
				return;
			}
			if (_win.close) {
				console.log('success: wxWindow closed');
				_win.close();
				_win = null;
				return;
			}
			console.log('failed: wxWindow.close not found');
		},
		/**
		 * 微信登录成功回调
		 */
		loginSuccess({ token, info }) {
			console.log('微信登录成功默认回调方法，请在外部重置该方法:token=' + token);
		}
	};
})();
